import styled from "styled-components";

export const IconBox = styled.button`
  min-width: 14px;
  min-height: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;

  svg {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;
